import { Grid, Stack, Typography } from '@mui/material';
import InfiniteScroll from 'react-infinite-scroll-component';
import { useNavigate } from 'react-router-dom';

import { Icon, Loading, Mask, Pill } from '@hapvida/hapvida-core-components';

import { NEW_COLORS } from '@hapvida/hapvida-core-components/src/themes/colors/newColors';

import { getPillColor } from '@flows/private/financial/helpers/getPillColor';
import { BillDetailRouter } from '@flows/private/financial/pages/Detail/router';

import { ActionButton, Line, StyledGrid } from './styles';
import type { BillsListCardMobileProps } from './types';

export function BillsListCardMobile({
  billsList,
  hasNextPage,
  fetchNextPage,
}: Readonly<BillsListCardMobileProps>) {
  const navigate = useNavigate();

  const billData = billsList?.pages?.map(bill => bill?.bills).flat() ?? [];

  return (
    <InfiniteScroll
      dataLength={billData?.length}
      hasMore={!!hasNextPage}
      next={fetchNextPage}
      loader={<Loading animationProps={{ height: 20, width: 20 }} />}
      height={'800px'}
    >
      <Grid container gap={1} flexDirection="row" flexWrap="wrap">
        {billData?.map(bill => (
          <Grid item xs={12} key={bill?.number}>
            <Line container alignItems="center">
              <Stack
                flexDirection="row"
                alignItems="flex-start"
                mb={2}
                width="100%"
                justifyContent="space-between"
              >
                <Stack
                  alignItems="flex-start"
                  justifyContent="flex-start"
                  gap={1}
                >
                  <Typography variant="body2">{bill?.billType}</Typography>
                  <Typography variant="body2">{bill?.number}</Typography>
                  <Typography variant="body2" fontWeight={700}>
                    {Mask.date(bill?.dueDate)}
                  </Typography>
                </Stack>
                <Stack
                  alignItems="flex-end"
                  justifyContent="space-between"
                  gap={1}
                >
                  <Pill
                    color={getPillColor(bill?.status)}
                    text={bill?.status}
                    fitContent
                  />
                  <Typography variant="body2" fontWeight={700}>
                    {Mask.currency(bill?.amount)}
                  </Typography>
                </Stack>
              </Stack>
              <StyledGrid item xs={12}>
                <ActionButton
                  onClick={() =>
                    navigate(
                      BillDetailRouter.dynamicPath({
                        billNumber: bill.number,
                      }),
                    )
                  }
                  color="secondary"
                  variant="contained"
                  size="small"
                  fullWidth
                  endIcon={
                    <Icon
                      color={NEW_COLORS.BASE.WHITE}
                      name="actions-b2b-chevron-right"
                      size={20}
                    />
                  }
                >
                  Ver mais
                </ActionButton>
              </StyledGrid>
            </Line>
          </Grid>
        ))}
      </Grid>
    </InfiniteScroll>
  );
}
